import { Box } from "@mui/material";
import { useStore } from "@priolo/jon";
import PlaceholderCmp, { ICON_TYPE } from "components/controls/PlaceholderCmp";
import { FunctionComponent, useEffect } from "react";
import incidentSo from "stores/incidents";
import { Cycle } from "types/Cycle";
import IncidentCard from "../../../incident/IncidentCard";
import IncidentDialog from "../../../incident/IncidentDialog";


interface Props {
    cycle: Cycle
}
const IncidentsTab: FunctionComponent<Props> = ({
    cycle
}) => {

    // STORE
    useStore(incidentSo)

    // HOOKs
    useEffect(() => {
        if (!cycle?.id) return
        incidentSo.fetchFromCycleId(cycle.id)
        incidentSo.fetchTypesIfVoid()
    }, [cycle?.id])

    // RENDER
    const incidents = incidentSo.state.all ?? []

    return <>
        {!incidents?.length ? (
            <PlaceholderCmp
                title="THERE ARE NO INCIDENTS"
                subtitle="Click on 'NEW INCIDENT' to create one"
                iconType={ICON_TYPE.VOID}
            />
        ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {incidents.map(incident =>
                    <IncidentCard key={incident.id}
                        incident={incident}
                        cycle={cycle}
                    />
                )}
            </Box>
        )}
        <IncidentDialog
            cycle={cycle}
        />
    </>
}

export default IncidentsTab
